import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Shield, Zap, Globe, History, Users, Lock, TrendingUp, BarChart } from 'lucide-react';

const Features = () => {
  const features = [
    {
      icon: Shield,
      title: '100% Undetectable',
      description: 'Tested against Turnitin, GPTZero, Originality.ai, and all major AI detectors. Our humanizer actually works.'
    },
    {
      icon: Zap,
      title: 'Lightning Fast',
      description: 'Process thousands of words in seconds. No more waiting around for results.'
    },
    {
      icon: Globe,
      title: 'Multiple Styles',
      description: 'Academic, casual, and professional writing styles. Perfect for any content type.'
    },
    {
      icon: History,
      title: 'Full History',
      description: 'Access all your past results anytime. Download, share, or reuse your humanized text.'
    },
    {
      icon: Users,
      title: 'Bulk Processing',
      description: 'Process multiple documents at once. Perfect for large projects and deadlines.'
    },
    {
      icon: Lock,
      title: 'Private & Secure',
      description: 'Your content is encrypted and private. We never share or use your data.'
    },
    {
      icon: TrendingUp,
      title: 'Always Improving',
      description: 'Our AI is constantly learning and improving to stay ahead of new detection methods.'
    },
    {
      icon: BarChart,
      title: 'Multi-Detector Scoring',
      description: 'See how your text performs against 6+ major AI detectors in real-time.'
    }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <div className="flex-1 py-24">
        <div className="container mx-auto">
          <div className="text-center mb-16">
            <Badge className="mb-4" variant="secondary">Features</Badge>
            <h1 className="text-4xl md:text-6xl font-heading font-black tracking-tighter mb-6">
              Everything You Need
            </h1>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Powerful features designed for writers, students, and professionals who use AI.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature) => {
              const Icon = feature.icon;
              return (
                <Card key={feature.title} className="p-8 border-zinc-200 hover:shadow-lg transition">
                  <Icon className="h-12 w-12 mb-4 text-primary" />
                  <h3 className="font-heading font-bold text-xl mb-2">{feature.title}</h3>
                  <p className="text-muted-foreground leading-relaxed">{feature.description}</p>
                </Card>
              );
            })}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Features;
